<div>

  <!-- ACTION BAR -->
  <div class="action-bar noPrint">

    <button mat-raised-button color="primary" (click)="printReport()">
      Print
    </button>

    <button mat-dialog-close class="btn" color="accent">
      Close
    </button>

    <button
      *ngIf="updateStatus"
      mat-raised-button
      color="primary"
      style="margin-left: 10px;"
      (click)="saveSubscriptionBarcodesDataEntry()">
      Save
    </button>

  </div>

  <!-- PRINT AREA -->
  <div id="print-section" class="print-wrapper">

    <table class="report-table">

      <!-- HEADER -->
      <tr>
        <th colspan="3"
            style="border:1px solid black; padding:8px; font-weight:600; font-size:15px; text-align:center; position:relative;">

          <span style="float:left;font-size:13px;">&nbsp;</span>

          विवेक पुस्तक प्रकाशन -
          पुस्तकाचे नाव - {{ book_name }}

          <span style="float:right;font-size:13px;">
            वितरण दि. - {{ dispatchDisplayDate }}
          </span>

        </th>
      </tr>

      <!-- COLUMN HEADER -->
      <tr>
        <th style="width:25%;">राज्य</th>
        <th style="width:25%;">वर्गणीदार संख्या</th>
        <th style="width:25%;">प्रति संख्या</th>
      </tr>

      <!-- LOADING -->
      <tr *ngIf="isLoading">
        <td colspan="3" class="loading">Loading...</td>
      </tr>

      <!-- DATA -->
      <ng-container *ngIf="!isLoading">

        <tr *ngFor="let item of filteredstatewisesubcount">

          <td>{{ item.state }}</td>
          <td>{{ item.total_booksellers }}</td>
          <td>{{ item.total_book_copies }}</td>

        </tr>

        <!-- NO DATA -->
        <tr *ngIf="filteredstatewisesubcount.length === 0">
          <td colspan="3" class="no-data">No Data Available</td>
        </tr>

        <!-- TOTAL -->
        <tr *ngIf="filteredstatewisesubcount.length > 0" class="total-row">

          <td>एकूण</td>
          <td>{{ total_sub_count }}</td>
          <td>{{ totalparcel }}</td>

        </tr>

      </ng-container>

    </table>

  </div>

</div>